import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import makeListRequest from './makeQueryParams';
import registerWindow from './window';

const attributesObjRef = {
  instruction_obsolete: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
};
const attributesObj = {
  property_id: {
    serverSide: true,
    type: 'or',
    values: [],
  },
  contract_id: {
    serverSide: true,
    type: 'or',
    values: [],
  },
  instruction_obsolete: {
    serverSide: true,
    values: ['N'],
  },
};

const refreshItemsWithDate = ({ dispatch, getters }) => {
  if (getters.attributesObj.instruction_obsolete.values.length !== 0) {
    dispatch('setDatesFilter', {
      dateMin: new Date(),
    });
  }

  dispatch('initItems');
};

const dateMin = new Date();

export default (store) => {
  store.registerModule(
    ['instructions'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2C_BASE_URI}/dispatcher_instructions`,
        }),
        treatListResponse: treatsItems({
          datetimeFieldNames: ['end_datetime', 'start_datetime'],
        }),
      }),
      customActions: { refreshItemsWithDate },
      sortChoices: ['start_datetime'],
      attributesObjRef,
      attributesObj,
      dateMin,
      makeQueryParams: makeListRequest({
        dateField: 'end_datetime',
        dateNullable: true,
        useEntities: true,
      }),
    })
  );
  registerWindow(store);

  const basePlugin = new BaseModulePlugins({
    module: 'instructions',
    store,
  });

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});

  basePlugin.onInit(() => {
    basePlugin.loadItemsOnCurrentEntityChange();

    store.subscribe((mutation) => {
      if (
        mutation.type === 'instructions/SET_ATTRIBUTES_OBJ' &&
        !store.getters['instructions/window/isOpen']
      )
        store.dispatch('instructions/window/setOpen', true);
    });
  });
};
